import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle, memo } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    Tooltip,
    ButtonGroup,
    Stepper,
    StepButton,
    Step,
    Checkbox,
    Typography,
    MenuItem,
    ListItemIcon,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { Add, AddBox, AddCircle, AutoFixHigh, CheckBoxOutlineBlank, ChevronRight, Close, ColorLens, Delete, Edit, Functions, InsertLink, LibraryAddCheck, Link, PlusOne, Repartition, Save, } from '@mui/icons-material';

import { myTimestampToDate, propComparatorDate, propComparatorDateTime } from '../utils/ui_utils';
import { useAuth } from '../core/AuthProvider';
import { addMinutes, differenceInMinutes, format, subMinutes } from 'date-fns';
import { globalstyles } from '../lib/definitions';
import { chunk } from '../utils/ui_utils';
import { CowSublistDialog } from './CowSublistDialog';
import { NumberInput } from '../components/NumberInput';
import { MatchDialog, newmatch } from './MatchDialog';
import { useEvent } from '../context/eventContext';
import { DateTimePicker } from '@mui/x-date-pickers';
import { add_Match, delete_Match, edit_Match } from '../FirebaseUtils/dbMatch';

const newmatch_settings = {
    min_count: 2,
    max_count: 35,
    duration: 30,
    planned_start: new Date()
}




const step_list = [
    { label: 'Inizializzazione gare', id: 0 },
    { label: 'Finalizza programma gare', id: 1 },
]


export const MatchInitWizardDialog = ({ category_list, closeMenu }) => {
    const { user } = useAuth()

    const manualChooseRef = useRef()
    const cowlistRef = useRef()
    const dialogRef = useRef()
    const { selEvent } = useEvent()

    const [open, setOpen] = useState(false);
    const [element_list, setElementList] = useState([])
    const [curElement, setCurElement] = useState({ ...newmatch_settings, planned_start: selEvent.event_start || new Date() })
    const [isEdited, setIsEdited] = useState(false)
    const [match_list, setMatchList] = useState([])
    const [activeStep, setActiveStep] = useState(0)
    const [selected_list, setSelected] = useState([])

    const [useLimit, setUseLimit] = useState(false)
    const selectAll = () => {
        setSelected(Array(match_list.length).fill().map((x, i) => i))
    }

    const deselectAll = () => {
        setSelected([])
    }


    const onChangeSelect = (el) => {
        let { name, value, type } = el
        setSelected(kd => {
            let _kd = [...kd]
            const k = kd.indexOf(parseInt(name, 10))
            console.log(k)
            if (k < 0) {
                console.log("ADD")
                _kd.push(parseInt(name, 10))
            } else {
                console.log("REMOVE")
                _kd.splice(k, 1)
            }
            return _kd
        })
    }

    const handleOpen = () => {
        initData()
        setCurElement(e => ({ ...e, planned_start: selEvent.event_start }))
        setOpen(true);
    };

    const handleClose = async () => {
        setMatchList([])
        for (const m of match_list) {
            await delete_Match(selEvent.id, m.id)
        }
        setOpen(false);
    };



    const handleSave = () => {
        for (const m of match_list) {
            let _m = { ...m }
            delete _m.is_temp
            edit_Match(user.uid, selEvent.id, m.id, _m)
        }
        setOpen(false);
    }



    const addMatch = async (el, k) => {
        const res = await add_Match(user.uid, selEvent.id, { ...el, is_temp: true })
        setMatchList(m => {
            let _m = [...m]
            if (m[k + 1]) {
                _m.splice(k + 1, 0, { ...el, id: res, is_final: true })
            } else {
                _m.push({ ...el, id: res, is_final: true })
            }
            _m = _m.map((mm, mk) => {
                if (mk <= (k)) {
                    return mm
                } else {
                    return { ...mm, planned_start: addMinutes(myTimestampToDate(mm.planned_start), curElement.duration) }
                }
            })
            _m.sort(propComparatorDate('planned_start'))
            return _m
        })

    }

    const removeMatch = (k) => {
        setMatchList(m => {
            let _m = [...m]
            _m.splice(k, 1)
            _m = _m.map((mm, mk) => {
                if (mk <= (k - 1)) {
                    return mm
                } else {
                    return { ...mm, planned_start: subMinutes(myTimestampToDate(mm.planned_start), curElement.duration) }
                }
            })
            return _m
        })
    }

    const editMatch = (el, k) => {
        if (Array.isArray(k)) {
            setMatchList(m => {
                let _m = [...m]
                for (const kk of k) {
                    _m.splice(kk, 1, { ...m[kk], ...el })
                }
                return _m
            })
            setSelected([])
        } else {
            setMatchList(m => {
                let _m = [...m]
                const delta_minutes = differenceInMinutes(myTimestampToDate(el.planned_start), myTimestampToDate(m[k].planned_start))
                _m.splice(k, 1, { ...el })
                /*                 _m = _m.map((mm, mk) => {
                                    if (mk <= (k)) {
                                        return mm
                                    } else {
                                        return { ...mm, planned_start: addMinutes(myTimestampToDate(mm.planned_start), delta_minutes) }
                                    }
                                }) */
                _m.sort(propComparatorDateTime('planned_start'))
                return _m
            })

        }

    }


    const handleAddMatch = (m, k) => {
        const planned_start = match_list[k + 1] ? match_list[k + 1].planned_start : addMinutes(myTimestampToDate(match_list[k].planned_start), curElement.duration)
        console.log(planned_start)
        dialogRef.current.onNew(planned_start, k)
    }

    const handleEditMatch = (m, k) => {
        dialogRef.current.onEdit(m, k)
    }

    const initData = async () => {
        if (category_list) {
            setElementList(category_list)
            let _match_list = process_data(category_list, true)
            let _new_match_list = []
            for (const m of _match_list) {
                let _m = { ...m }
                const res = await add_Match(user.uid, selEvent.id, { ...m, is_temp: true })
                _m.id = res
                _new_match_list.push(_m)
                console.log(res)
            }
            setMatchList(_new_match_list)
        } else {
            console.log("ERROR")
        }
    }

    useEffect(() => {
        if (element_list.length > 0) {
            setMatchList(ml => {
                let newStart = myTimestampToDate(curElement.planned_start)
                let _ml = [...ml]
                _ml = _ml.map((m, k) => ({
                    ...m,
                    planned_start: addMinutes(newStart, k * curElement.duration)
                }))
                console.log("NEW ML DATA")
                return _ml
            }
            )
        }

    }, [element_list, curElement, useLimit])



    const process_data = (c_list, first_init) => {
        console.log("PROCESS DATA", element_list)
        if (curElement.planned_start) {
            let match_list = []
            let newStart = myTimestampToDate(curElement.planned_start)
            if (first_init) {
                match_list = c_list.map((c, k) => ({
                    ...newmatch, match_name: c.category_name,
                    match_description: c.category_description,
                    link_to_category: true,
                    linked_category: { category_name: c.category_name, category_description: c.category_description, id: c.id },
                    cow_list: [],
                    is_public: false,
                    planned_start: addMinutes(newStart, k * curElement.duration)
                }))
                return match_list
            } else {
            }
        }
    }



    const handleEditMulti = () => {
        dialogRef.current.onEdit(match_list[selected_list[0]], selected_list)
    }

    const handleAddSectionFinal = () => {
    }

    const showCowlist = (cow_list, cat) => {
        cowlistRef.current.onOpen(cow_list, { id: cat.id, title: cat.category_name + " " + cat.category_description })
    }


    const onChangeHandler = (el, is_multi) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (is_multi) {
            setCurElement({ ...curElement, ...el })
            setIsEdited(true)

        } else {

            if (type === 'radio') {
                if (value === 'true') {
                    value = true
                } else if (value === 'false') {
                    value = false
                }
            } else if (type === 'checkbox') {
                value = el.checked
            } else if (type === 'number') {
                value = parseInt(value)
            }

            if (value !== undefined) {
                setCurElement({ ...curElement, [name]: value })
                setIsEdited(true)
            }
        }
    }

    return (
        <div>
                <MenuItem onClick={() => {handleOpen(); closeMenu()}} disableRipple>
                    <ListItemIcon>
                        <AutoFixHigh />
                    </ListItemIcon>
                    Wizard inizializzazione gare
                </MenuItem>
            <CowSublistDialog ref={cowlistRef} />
            <MatchDialog
                ref={dialogRef}
                event_id={selEvent.id}
                addFn={addMatch}
                editFn={editMatch}
                category_list={category_list}
                element_list={match_list}
            />
            <Dialog open={open} onClose={handleClose} fullScreen={true}>
                <DialogTitle>
                    Wizard inizializzazione gare
                    <Grid container spacing={2} justifyContent={"space-around"}>
                        <Grid size={2}>
                            <NumberInput
                                value={curElement.duration}
                                onChangeHandler={onChangeHandler}
                                setCurElement={setCurElement}
                                setIsEdited={setIsEdited}
                                label={"durata gara (min)"}
                                name="duration"
                            />

                        </Grid>
                        <Grid size={2}>
                            <DateTimePicker
                                variant="outlined"
                                size="small"
                                sx={{ mt: 0.8 }}
                                label={'inizio previsto (prima gara)'}
                                name={'planned_start'}
                                slotProps={{ field: { size: 'small' } }}
                                id={'planned_start'}
                                value={myTimestampToDate(curElement.planned_start)}
                                onChange={(nv) => onChangeHandler({ value: nv, name: 'planned_start' })} />

                        </Grid>
                        <Grid size="grow">
                            <ButtonGroup>
                                <Button size="small" startIcon={<Edit />} color="warning" disabled={selected_list.length === 0} onClick={handleEditMulti}>Modifica Multipla (seleziona più gare)</Button>
{/*                                 <Button size="small" startIcon={<Edit />} color="warning" disabled={selected_list.length === 0} onClick={handleAddSectionFinal}>Aggiungi finale dopo ogni sezione</Button> */}
                            </ButtonGroup>

                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid sx={globalstyles.list_container} size="grow" flexDirection={"column"}>
                            <Grid sx={globalstyles.sectionHeader}>
                                preview gare
                            </Grid>
                            <Grid container sx={globalstyles.listHeader}>
                                <Grid size="grow">
                                    Nome categoria
                                </Grid>
                                <Grid size={"grow"}>
                                    inizio
                                </Grid>
                                <Grid size={"grow"}>
                                    premi assegnati
                                </Grid>
                                <Grid size={"grow"}>
                                    sorgente soggetti
                                </Grid>
                                <Grid size={2} textAlign={"right"}>
                                    <ButtonGroup size="small" color="light">
                                        <Button onClick={deselectAll} startIcon={<CheckBoxOutlineBlank />}></Button>
                                        <Button onClick={selectAll} startIcon={<LibraryAddCheck />}></Button>
                                    </ButtonGroup>
                                </Grid>
                            </Grid>
                            {match_list.map((c, k) => (
                                <OneMatch
                                    key={k}
                                    match={c}
                                    index={k}
                                    doShow={() => showCowlist(c.cow_list, { id: c.id, category_name: c.match_name, category_description: c.match_description })}
                                    min_count={curElement.min_count}
                                    max_count={curElement.max_count}
                                    curStep={activeStep}
                                    selected={selected_list.includes(k)}
                                    addMatch={() => handleAddMatch(c, k)}
                                    editMatch={() => handleEditMatch(c, k)}
                                    removeMatch={() => removeMatch(k)}
                                    onSelect={(kk) => onChangeSelect(kk)}
                                />
                            ))}
                        </Grid>

                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                    <Button key={'bs'} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" >Concludi procedura </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}



const OneMatch = memo(({ match, min_count, max_count, doShow, addMatch, removeMatch, editMatch, curStep, onSelect, index, selected }) => {

    const c_length = match.cow_list.length



    let color = 'black'
    let outside = 0
    if (c_length === 0) {
        color = 'grey'
    } else if (c_length < min_count) {
        color = 'orange'
    } else if (c_length <= max_count) {

    } else {
        outside = c_length - max_count
        color = 'red'
    }
    return (
        <Grid container sx={{ ...globalstyles.list_row, color: color }}>
            <Grid size={"grow"}>
                {match.match_name}
                <Typography sx={{ fontSize: '0.7em' }}>
                    {match.match_description}
                </Typography>
            </Grid>
            <Grid size={"grow"}>
                {format(myTimestampToDate(match.planned_start), 'HH:mm')}
            </Grid>
            <Grid size={"grow"} sx={match.award_list.length === 0 ? { color: 'red' } : {}}>
                {match.award_list.length} premi
            </Grid>
            <Grid size={"grow"}>
                {match.link_to_category &&

                    <Tooltip title={<>lista collegata a categoria {match.linked_category?.category_name}<br /></>}>
                        <span>
                            <InsertLink color="success" />
                        </span>
                    </Tooltip>
                }
                {match.use_dynamic_list &&
                    <Tooltip title={`lista dinamica da ${match.source_list_data ? Object.keys(match.source_list_data).length : '0'} gare`}>
                        <span>
                            {match.award_list?.filter(a => a.from_other_data).length > 0 ?
                                <Functions color="secondary" />
                                :
                                <Repartition color='secondary' />
                            }
                        </span>
                    </Tooltip>
                }
            </Grid>
            <Grid size={"grow"} sx={{ textAlign: 'right' }}>
                <Checkbox
                    size="small"
                    checked={selected}
                    name={index + ''}
                    onChange={(ev) => onSelect(ev.target)}
                    inputProps={{ 'aria-label': 'controlled' }}
                />
                <ButtonGroup size="small">
                    {match.cow_list.length > 0 &&
                        <Tooltip title="visualizza soggetti in gara">
                            <Button color="secondary" onClick={doShow}>soggetti</Button>
                        </Tooltip>
                    }
                    {match.cow_list.length === 0 &&
                        <Button color="error" onClick={removeMatch} startIcon={<Delete />}></Button>
                    }
                    <Button color="warning" onClick={editMatch} startIcon={<Edit />}></Button>
                    <Tooltip title="aggiungi nuova gara dopo questa">
                        <Button onClick={addMatch} startIcon={<PlusOne />}></Button>
                    </Tooltip>
                </ButtonGroup>
            </Grid>
        </Grid>

    )
})